import React from 'react'
import RawTableCell from '@mui/material/TableCell'

const TableCell = ({children, sx, ...p}) => {
    return (
        <RawTableCell sx={{fontSize: '0.75rem', padding: 0, ...sx}} {...p}>
            {children}
        </RawTableCell>
    )
}

export default TableCell
